import { Divider, Grid, Typography } from '@material-ui/core';
import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router';
import { UrlParams } from 'src/modules/shared/types';
import { useGetTableOfContentQuery } from 'src/store/table-of-contents/tableOfContentsApi';
import { TableOfContentsImage } from './components/Image/TableOfContentsImage';
import { ChapterReminder } from './components/ChapterReminder/ChapterReminder';
import { setExpandedIndex } from 'src/store/table-of-contents/tableOfContentsSlice';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { setNavigationPlace } from 'src/modules/shared/slices/navigationBar/navigationBarSlice';
import { setBookId } from 'src/modules/shared/slices/book/bookEntity';
import { VideoPageHelper } from 'src/components/VideoPageHelper/VideoPageHelper';
import { TableOfContentsChapter } from './components/Chapter/TableOfContentChapters';
import { TOCToolbox } from './components/Toolbox/TOCToolbox';
import { useRequestMeMutation } from 'src/modules/shared/slices/auth/entity/api/auth';
import { PlataformGuidePlace } from 'src/store/plataform-guide/types';

export const TableOfContents: FC = () => {
  const dispatch = useAppDispatch();
  let params = useParams<UrlParams>();
  const { bookId, chapterId } = params;

  const { chapterToRemind, clickedOnNavBar } = useAppSelector((state) => state.tableOfContents);
  const reduxBookId = useAppSelector((state) => state.books.bookId);

  const { data } = useGetTableOfContentQuery(bookId ?? '', {
    skip: !bookId,
    refetchOnMountOrArgChange: true,
  });

  const [, { data: meResponse, isSuccess }] = useRequestMeMutation({
    fixedCacheKey: '/me',
  });

  useEffect(() => {
    if (bookId && bookId !== reduxBookId) {
      dispatch(setBookId(bookId));
    }
  }, [bookId, dispatch, reduxBookId]);

  useEffect(() => {
    if (chapterId) dispatch(setExpandedIndex(chapterToRemind));
    dispatch(setNavigationPlace('table-of-contents'));
  }, [chapterToRemind, dispatch, chapterId]);

  useEffect(
    () => () => {
      dispatch(setNavigationPlace(null));
      dispatch(setExpandedIndex(''));
    },
    [dispatch]
  );

  return (
    <>
      {!meResponse?.stepper?.key && isSuccess && (
        <VideoPageHelper place={PlataformGuidePlace.TableOfContents} />
      )}
      {(chapterId || clickedOnNavBar) && <ChapterReminder />}
      <Typography variant="h1">{data?.title} </Typography>
      <Divider style={{ margin: '25px 0' }} />
      <Grid container spacing={3}>
        <Grid item sm={9} xs={12}>
          {data?.demoInformation && (
            <div dangerouslySetInnerHTML={{ __html: data?.demoInformation }} />
          )}
        </Grid>
        <Grid item sm={3} xs={12}>
          <TableOfContentsImage />
        </Grid>
      </Grid>
      <TableOfContentsChapter />
      <TOCToolbox />
    </>
  );
};
